import { useEffect } from "react";

const PlansModal = ({ plan }) => {
    console.log(plan);
    useEffect(() => {
        return () => {
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
                document.body.classList.remove("modal-open");
                document.body.style = "";
            }
        };
    }, []);
    return (
        <>
            <div
                className="modal fade m-0 p-0"
                tabIndex={-1}
                id={`machine-details-plan`}
                aria-modal
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <button className="close" data-bs-dismiss="modal">
                            <em
                                className="icon ni ni-cross"
                                aria-hidden="true"
                            ></em>
                        </button>
                        <div className="modal-header">
                            <h5 className="modal-title">
                                Plan{" "}
                                {`(${plan?.work_order} : ${plan?.daily_plan})`}
                            </h5>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 mb-2">
                                    <p>
                                        <strong>Item</strong>: {plan?.item_name}
                                    </p>
                                </div>
                                <div className="col-md-12 mb-2">
                                    <p>
                                        <strong>Actual Machine Cycles</strong>:{" "}
                                        {plan?.actual_machine_cycles}
                                    </p>
                                </div>
                                <div className="col-md-12 mb-2">
                                    <p>
                                        <strong>Actual Prouction</strong>:{" "}
                                        {plan?.actual_production}
                                    </p>
                                </div>
                                <div className="col-md-12 mb-2">
                                    <p>
                                        <strong>Expected Production</strong>:{" "}
                                        {plan?.expected_production}
                                    </p>
                                </div>

                                <div className="col-md-12 mb-2">
                                    <p>
                                        <strong>On Hold</strong>:{" "}
                                        {plan?.on_hold}
                                    </p>
                                </div>
                                <div className="col-md-12 mb-2">
                                    <p>
                                        <strong>Rejected</strong>:{" "}
                                        {plan?.rejected}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PlansModal;
